








import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

@Component
export default class AccessDateRows extends Vue {
  @Prop() accessData!: Array<any>;

  accessDataStyles: Array<any> = [];

  @Watch('accessData')
  onValueChange (): void {
    console.log('access data changed', this.accessData)
    this.accessDataStyles = []
    this.date2AccessDomData()
  }

  mounted () {
    this.date2AccessDomData()
  }

  private date2AccessDomData (): void {
    console.log(this.accessData, this.accessData.length)
    if (this.accessData.length === 0) {
      console.log('return')
      return
    }
    let baseDate = new Date(this.accessData[0].from)
    baseDate = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 0, 0, 0)
    console.log('Date range:', baseDate, this.accessData[0].from, this.accessData[0].to)
    for (let i in this.accessData) {
      let top = this.duration2Pixel(new Date(this.accessData[i].from).getTime() - baseDate.getTime())
      let height = this.duration2Pixel(new Date(this.accessData[i].to).getTime() - new Date(this.accessData[i].from).getTime())
      this.accessDataStyles.push({ id: new Date(this.accessData[i].from).getTime() + '-' + height, top: top, height: height })
    }
    console.log(this.accessDataStyles)
  }

  // return pixel
  private duration2Pixel (duration: number): number {
    console.log(duration)
    let minutes = Math.round(duration / 1000 / 60)
    // 0.5 pixels per minute
    // 最低5分ずつ表示される
    let pixels = Math.max(minutes * 0.5, 2.5)
    return pixels
  }
}
